const classNames = (...names) => names.filter(name => typeof name === 'string').join(' ')
export default classNames
